import { render, staticRenderFns } from "./attenshiftdiolg.vue?vue&type=template&id=7a63ce7c&scoped=true"
import script from "./attenshiftdiolg.vue?vue&type=script&lang=js"
export * from "./attenshiftdiolg.vue?vue&type=script&lang=js"
import style0 from "./attenshiftdiolg.vue?vue&type=style&index=0&id=7a63ce7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63ce7c",
  null
  
)

export default component.exports